import { createSelector } from 'reselect';

import { StateDictionary } from '../reducers/utils/state-manager';

import { MergeSyncHealth } from './util/merge-sync-health-types';

export type MergeIntegrationTypeState = {
  mergeIntegrationsByOrgId: { [orgId: number]: MergeIntegration };
  mergeIntegrationsStateByOrgId: StateDictionary;
  mergeSyncHealthByOrgId: { [orgId: number]: MergeSyncHealth };
  mergeSyncHealthStateByOrgId: StateDictionary;
};

type State = { mergeIntegrations: MergeIntegrationTypeState };

const mergeIntegrationsByOrgIdSelector = (state: State) =>
  state.mergeIntegrations.mergeIntegrationsByOrgId;

export const mergeIntegrationForOrgIdSelector = createSelector(
  [mergeIntegrationsByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (mergeIntegrations, orgId) =>
    mergeIntegrations[orgId] && Object.entries(mergeIntegrations[orgId]).length
      ? mergeIntegrations[orgId]
      : undefined,
);

const mergeIntegrationsStateByOrgIdSelector = (state: State) =>
  state.mergeIntegrations.mergeIntegrationsStateByOrgId;
export const mergeIntegrationsStateForOrgIdSelector = createSelector(
  [mergeIntegrationsStateByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (mergeIntegrationsStateByOrgId, orgId) => mergeIntegrationsStateByOrgId[orgId],
);

const mergeSyncHealthByOrgIdSelector = (state: State) =>
  state.mergeIntegrations.mergeSyncHealthByOrgId;
export const mergeSyncHealthForOrgIdSelector = createSelector(
  [mergeSyncHealthByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (mergeSyncHealthByOrgId, orgId) => mergeSyncHealthByOrgId[orgId],
);

const mergeSyncHealthStateByOrgIdSelector = (state: State) =>
  state.mergeIntegrations.mergeSyncHealthStateByOrgId;
export const mergeSyncHealthStateForOrgIdSelector = createSelector(
  [mergeSyncHealthStateByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (mergeSyncHealthStateByOrgId, orgId) => mergeSyncHealthStateByOrgId[orgId],
);
